import React from 'react';
const months = [{
  label: 'Apr',
  revenue: 46,
  cost: 30
}, {
  label: 'May',
  revenue: 58,
  cost: 34
}, {
  label: 'Jun',
  revenue: 52,
  cost: 31
}, {
  label: 'Jul',
  revenue: 70,
  cost: 38
}, {
  label: 'Aug',
  revenue: 84,
  cost: 41
}];
export function ReportsMock() {
  return <div className="w-full max-w-[330px] rounded-[12px] bg-white p-5 shadow-[0_18px_40px_-24px_rgba(11,11,11,0.28)]" data-id="element-807" data-mp="1h9pnb10hkx46">
      <p className="text-[14px] font-semibold text-ink" data-id="element-808" data-mp="1m9c1bco52he1">Profit this month</p>
      <p className="mt-2 text-[24px] font-semibold tracking-[-0.02em] text-ink" data-id="element-809" data-mp="1r7x49jurzf66">4.1M</p>
      <p className="mt-1 text-[12px] font-medium text-brand" data-id="element-810" data-mp="1r5keikis00ik">+18% vs last month</p>

      <div className="mt-5 flex h-[104px] items-end gap-3" data-id="element-811" data-mp="1w0qakc5w6vkd">
        {months.map(m => <div key={m.label} className="flex flex-1 flex-col items-center gap-1.5" data-id="element-812" data-mp="1zzfihp85vkwm">
            <div className="flex h-[86px] w-full items-end justify-center gap-1" data-id="element-813" data-mp="250v5vnxta3i6">
              <div className="w-[9px] rounded-t-[3px] bg-brand" style={{
            height: `${m.revenue}%`
          }} data-id="element-814" data-mp="29zg5pm95il63" />
              <div className="w-[9px] rounded-t-[3px] bg-canvas-line" style={{
            height: `${m.cost}%`
          }} data-id="element-815" data-mp="1vl4tm85fdbio" />
            </div>
            <span className="text-[11px] text-ink-muted" data-id="element-816" data-mp="1mj3xxfpuaxj4">{m.label}</span>
          </div>)}
      </div>

      <div className="mt-3 flex items-center gap-4 border-t border-canvas-line pt-3 text-[11px]" data-id="element-817" data-mp="1hku2d407duwz">
        <span className="inline-flex items-center gap-1.5 text-ink" data-id="element-818" data-mp="2eb322pd4x6mu">
          <span className="h-2 w-2 rounded-full bg-brand" data-id="element-819" data-mp="2ece9r09payj8" />
          Sales
        </span>
        <span className="inline-flex items-center gap-1.5 text-ink-muted" data-id="element-820" data-mp="2ab2n93m4itf9">
          <span className="h-2 w-2 rounded-full bg-canvas-line" data-id="element-821" data-mp="25gor2yzn0i9j" />
          Costs
        </span>
      </div>
    </div>;
}